import React from "react";
import styles from "../../../styles/components/CopyWriterDashboard/copy-writer-completed-video-accordian.module.scss";
import { Box, Button } from "@mui/material";
import Accordion from "@mui/material/Accordion";
import AccordionSummary from "@mui/material/AccordionSummary";
import AccordionDetails from "@mui/material/AccordionDetails";
import Typography from "@mui/material/Typography";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import sendProductIcon from "../../../public/assets/images/sendProductIcon.svg";

const RevisedVideoaccordian = ({ title, requester}) => {
  return (
    <>
      <Box className={`${styles.vsidWrapperRed}`}>
        <Accordion>
          <AccordionSummary
            expandIcon={<ExpandMoreIcon />}
            aria-controls="panel1a-content"
            id="panel1a-header"
          >
            <Box className={styles.vsidWrapperHeading}>
              <Typography variant="body1">
             {title}
              </Typography>
            </Box>
          </AccordionSummary>
          <AccordionDetails>
            <Box className={styles.accordianBoxcontent}>
              <Box className={styles.contentTop}>
                <Typography variant="body1">
                  Requester: <Typography variant="caption">{requester ? requester : 'Admin'} </Typography>
                </Typography>
                <Typography variant="body1">
                  Date:
                  <Typography variant="caption">
                    December 25, 2022 at 10:45:22 AM UTC.
                  </Typography>
                </Typography>
              </Box>
              <Typography>Requester’s Comment:</Typography>
              <Box className={styles.commentBox}>
                <Typography variant="body1">
                  The title is not matching the details provided by the content
                  owner. please review it and let the editors know that the
                  title and description are updated.
                </Typography>
              </Box>
            </Box>
          </AccordionDetails>
        </Accordion>
      </Box>
    </>
  );
};

export default RevisedVideoaccordian;
